import {InitPxVideo} from "./px-video.js";

document.addEventListener("DOMContentLoaded", function() {

    const element = document.getElementById('player');
    const dataTitleValue = element.getAttribute('data-title');

    InitPxVideo({
        "videoId": 'player',
        "captionsOnDefault": false,
        "seekInterval": 20,
        "videoTitle": dataTitleValue,
        "isAudio": 'false',
        "debug": true
    });
});
    